module.exports = __webpack_public_path__ + "img/weixin.30379100.svg";